// extracted by mini-css-extract-plugin
export default {"ssl-icon":"BEVph4","sslIcon":"BEVph4"};